"use client";

import { SessionProvider } from "next-auth/react";
import { Toaster } from "react-hot-toast";

export default function ClientProviders({ children }: { children: React.ReactNode }) {
  return (
    <SessionProvider>
      <Toaster
        position="top-right"
        // above the popups (z-index 10000), so a message is never hidden behind one
        containerStyle={{ zIndex: 100000 }}
        toastOptions={{
          style: {
            margin: "15px",
            background: "#828282",
            color: "#fff",
            fontSize: "15px",
            width: "340px",
          },
          className: "text-base",
          duration: 3000,
        }}
      />
      {children}
    </SessionProvider>
  );
}
